import { useState } from 'react';

import { UnsavedChangesDialog } from '@/components/form/UnsavedChangesDialog';
import { Button } from '@/components/ui/Button';

import { State } from '../State';

/**
 * Driven by local state rather than the real hook, so trying it never holds a
 * real navigation on this page.
 */
export function UnsavedChangesDialogExamples() {
  const [blocked, setBlocked] = useState(false);
  const close = () => setBlocked(false);

  return (
    <State
      title="The leave prompt"
      note="Stay is the first stop and the default; Escape means Stay."
    >
      <Button variant="secondary" onClick={() => setBlocked(true)}>
        Open the leave prompt
      </Button>
      <UnsavedChangesDialog blocked={blocked} stay={close} leave={close} />
    </State>
  );
}
